/// <amd-module name="Feed/Legacy/Protocols/Upstream/Constants/UpstreamConstants" />
import * as PackageResources from "Feed/Common/Resources";

export const UpstreamName = PackageResources.Upstream;

export class UpstreamCiConstants {
    public static UpstreamConnectToFeedPanel = "UpstreamConnectToFeedPanel";
    public static ProtocolName = UpstreamName;
}
